/**
 * @generated SignedSource<<0cfc0acbf8742da329a156f69c78441f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentReviewStatus = "NEEDED" | "NONE" | "REVIEWED";
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerCardHeaderReviewStatus_appointment$data = {
  readonly reviewStatus: AppointmentReviewStatus;
  readonly " $fragmentType": "appointmentDrawerCardHeaderReviewStatus_appointment";
};
export type appointmentDrawerCardHeaderReviewStatus_appointment$key = {
  readonly " $data"?: appointmentDrawerCardHeaderReviewStatus_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerCardHeaderReviewStatus_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerCardHeaderReviewStatus_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reviewStatus",
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "f4d85baf3f149896983213ce90b86c14";

export default node;
